import { __decorate } from "tslib";
import { Component, Watch } from 'vue-property-decorator';
import { Tile, TileSize, TextListWithAddons, ThumbnailsListWithAddons, ListType, TileSizeMobile } from '../../_components/ui';
import { ModuleAdditionalRows } from '../../_contracts';
import { InnerGridWrapper } from '../_partials';
import { TeaserBoxVersion } from '../TeaserBox.contracts';
import { TeaserBoxAddonsMixin } from '../TeaserBox.shared';
let TeaserBoxInnerGridXLSlider3STextList = class TeaserBoxInnerGridXLSlider3STextList extends TeaserBoxAddonsMixin {
    constructor() {
        super(...arguments);
        this.slides = [];
        this.gridConfig = {
            defaultSize: TileSize.S,
            mobileSize: TileSizeMobile.TILE_PLUS_TEXT,
            tiles: {
                0: TileSize.XL,
                1: TileSize.XL,
                2: TileSize.XL
            },
            listOffset: 6,
            listType: ListType.LIST
        };
        this.TileSize = TileSize;
        // --- Slider logic ---
        this.activeIndex = 0;
        this.nextIndex = 0;
        this.slideDurationMs = 5000;
        this.intervalId = null;
        this.isPaused = false;
        this.isTransitioning = false;
        this.isTransitioningIn = false;
        this.isTransitioningOut = false;
        // protected frozenBackgroundIndex: number | null = null
        // Pause/resume timing logic
        this.remainingTime = this.slideDurationMs;
        this.pauseStartTime = null;
        this.slideStartTime = null;
    }
    created() {
        this.slides = this.getTilesAndAddons().slice(0, 3);
        this.tiles = this.getTilesAndAddons().slice(3);
        this.listComponent = this.combineToListComponent();
    }
    get tilesOffset() {
        switch (this.teaserBoxConfig.additionalRows) {
            case ModuleAdditionalRows.addOne:
                return this.gridConfig.listOffset + 3;
            case ModuleAdditionalRows.addTwo:
                return this.gridConfig.listOffset + 6;
            default:
                return this.gridConfig.listOffset;
        }
    }
    get slidesCount() {
        return Math.min(3, Array.isArray(this.slides) ? this.slides.length : 0);
    }
    get currentHeroArticle() {
        if (!this.slides || this.slides.length === 0) {
            return null;
        }
        const index = this.activeIndex % this.slidesCount;
        return this.slides[index];
    }
    get nextHeroArticle() {
        if (!this.slides || this.slides.length === 0) {
            return null;
        }
        return this.slides[this.nextIndex];
    }
    // protected get currentTitleLines (): number {
    //   if (!this.currentHeroArticle) {
    //     return 2
    //   }
    //   const titleLength = (this.currentHeroArticle.data as ContentSneakPeakData).title.length
    //   return titleLength > 60 ? 3 : 2 // Same logic as isTitleLong for XL
    // }
    //
    // protected get titleLinesClass (): string {
    //   return `--title-lines-${this.currentTitleLines}`
    // }
    get sliderIndicator() {
        return {
            slidesCount: this.slidesCount,
            activeIndex: this.activeIndex % (this.slidesCount || 1),
            nextIndex: this.nextIndex,
            durationMs: this.slideDurationMs,
            isPaused: this.isPaused,
            isTransitioning: this.isTransitioning
        };
    }
    mounted() {
        this.setNextIndex();
        this.startSlider();
    }
    beforeDestroy() {
        this.stopSlider();
    }
    goToSlide(index) {
        this.setNextIndex(index);
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        setTimeout(() => {
            this.transitionToNextSlide();
        }, 100);
    }
    startSlider() {
        this.stopSlider();
        if (this.slidesCount <= 1 || this.isPaused) {
            return;
        }
        // Use remaining time for resume, or full duration for fresh start
        const delay = this.remainingTime;
        this.slideStartTime = Date.now();
        this.intervalId = window.setTimeout(() => {
            this.transitionToNextSlide();
            // After first transition, use regular interval
            this.startRegularInterval();
        }, delay);
    }
    startRegularInterval() {
        this.stopSlider();
        if (this.slidesCount <= 1 || this.isPaused) {
            return;
        }
        this.remainingTime = this.slideDurationMs;
        this.slideStartTime = Date.now();
        this.intervalId = window.setInterval(() => {
            this.transitionToNextSlide();
        }, this.slideDurationMs);
    }
    transitionToNextSlide() {
        if (this.isTransitioning) {
            return;
        }
        // this.frozenBackgroundIndex = this.activeIndex
        this.isTransitioning = true;
        this.isTransitioningOut = true;
        this.isTransitioningIn = false;
        // Reset remaining time for new slide
        this.remainingTime = this.slideDurationMs;
        this.slideStartTime = null;
        setTimeout(() => {
            this.isTransitioningOut = false;
            this.isTransitioningIn = true;
            this.activeIndex = this.nextIndex;
        }, 600); // $tile-transition-duration
        setTimeout(() => {
            this.isTransitioningIn = false;
            this.isTransitioningOut = false;
            this.isTransitioning = false;
            // this.frozenBackgroundIndex = null
        }, 1000); // $tile-transition-duration + backgroundChangeDelay
    }
    stopSlider() {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
    pauseSlider() {
        if (this.isMobile) {
            return;
        }
        this.isPaused = true;
        // Calculate remaining time if slider was running
        if (this.slideStartTime && !this.pauseStartTime) {
            const elapsed = Date.now() - this.slideStartTime;
            this.remainingTime = Math.max(0, this.remainingTime - elapsed);
        }
        this.pauseStartTime = Date.now();
        this.stopSlider();
    }
    resumeSlider() {
        this.isPaused = false;
        this.pauseStartTime = null;
        this.startSlider();
    }
    setNextIndex(index) {
        if (typeof index !== 'undefined') {
            this.nextIndex = index;
            return;
        }
        // const baseIndex = this.frozenBackgroundIndex !== null ? this.frozenBackgroundIndex : this.activeIndex
        // this.nextIndex = (baseIndex + 1) % this.slidesCount
        this.nextIndex = (this.activeIndex + 1) % this.slidesCount;
    }
    onActiveIndexChange() {
        this.setNextIndex();
    }
};
TeaserBoxInnerGridXLSlider3STextList.moduleVersion = TeaserBoxVersion['XL-slider-3S-text-list'];
__decorate([
    Watch('activeIndex')
], TeaserBoxInnerGridXLSlider3STextList.prototype, "onActiveIndexChange", null);
TeaserBoxInnerGridXLSlider3STextList = __decorate([
    Component({
        name: 'TeaserBoxInnerGridXLSlider3STextList',
        components: { InnerGridWrapper, Tile, TextListWithAddons, ThumbnailsListWithAddons },
        template: `
    <InnerGridWrapper>
    <template v-if="items && items.length">
      <!-- Tile / XL -->
      <component :is="getComponentType(currentHeroArticle)" v-bind="getComponentProps(currentHeroArticle)"
                 :window-service="windowService"
                 :class="{
                   '--transitioning-out': isTransitioningOut,
                   '--transitioning-in': isTransitioningIn,
                 }"
                 :article="currentHeroArticle.data"
                 :next-article="nextHeroArticle.data"
                 :slider-indicator="sliderIndicator"
                 @go-to-slide="goToSlide"
                 @mouseenter="pauseSlider"
                 @mouseleave="resumeSlider" />
      <template v-for="item in tiles">
        <component :is="getComponentType(item)" v-bind="getComponentProps(item)" :key="item.key" />
      </template>
      <template v-if="!isMobile && listComponent">
        <div :class="gridStyle">
          <component :is="listComponent.component" v-bind="getComponentProps(listComponent)"
                     :key="listComponent.key" />
        </div>
      </template>
    </template>
    </InnerGridWrapper>
  `
    })
], TeaserBoxInnerGridXLSlider3STextList);
export { TeaserBoxInnerGridXLSlider3STextList };
